module.exports = __webpack_public_path__ + "static/Jost-Light-2b363e2ebd1f52f1c0ebedeeac5b7098.woff";